import { Link } from "react-router-dom";
import { navLinks } from "@/lib/nav";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-20 w-full bg-primary-900 text-primary-50">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-10 px-4 py-14 md:grid-cols-2 md:px-8 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="mb-4 flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-50 text-primary-800">
              <i className="ri-scales-3-line text-lg" />
            </span>
            <span className="font-heading text-lg font-bold">乱伦专题</span>
          </div>
          <p className="text-sm leading-relaxed text-primary-100/80">
            聚焦近亲性关系相关的法律法规、伦理道德与社会规范，为公众、法律从业者与研究者提供严谨、可溯源的科普内容。
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold tracking-wide text-primary-100">内容分类</h4>
          <ul className="space-y-2.5 text-sm">
            {categories.map((category) => (
              <li key={category.type}>
                <Link
                  to={`/category/${category.type}`}
                  className="inline-flex items-center gap-2 text-primary-100/80 transition-colors hover:text-background-50"
                >
                  <i className="ri-arrow-right-s-line text-accent-300" />
                  {category.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold tracking-wide text-primary-100">快速导航</h4>
          <ul className="space-y-2.5 text-sm">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="inline-flex items-center gap-2 text-primary-100/80 transition-colors hover:text-background-50"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={`${link.icon} text-base`} />
                  </span>
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/search"
                className="inline-flex items-center gap-2 text-primary-100/80 transition-colors hover:text-background-50"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-base" />
                </span>
                全文搜索
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold tracking-wide text-primary-100">联系与说明</h4>
          <ul className="space-y-2.5 text-sm text-primary-100/80">
            <li className="flex items-start gap-2">
              <i className="ri-mail-line mt-0.5 text-accent-300" />
              <span>contact@incest-law-ethics.example</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line mt-0.5 text-accent-300" />
              <span>本网站为知识科普演示，地址信息从略</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-shield-line mt-0.5 text-accent-300" />
              <span>内容仅供学习参考，不构成法律意见</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-700/60">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-3 px-4 py-5 text-xs text-primary-100/70 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <p>© {new Date().getFullYear()} 乱伦专题 · 法律与伦理知识门户。保留所有权利。</p>
          <p className="flex items-center gap-2">
            <i className="ri-information-line" />
            本站示例数据为虚构或公开法规整理，请以现行法律为准。
          </p>
        </div>
      </div>
    </footer>
  );
}